import React from 'react';
import '../styles/Modal.css';

const Modal = ({ isOpen, title, message, onConfirm, onCancel, confirmText = 'OK', cancelText = 'Cancel', type = 'info', customContent = null }) => {
    if (!isOpen) return null;

    return (
        <div className="modal-overlay">
            <div className={`modal-content modal-${type}`}>
                <h2 className="modal-title">{title}</h2>
                {customContent ? (
                    <div className="modal-custom-content">
                        {customContent}
                    </div>
                ) : (
                    <p className="modal-message">{message}</p>
                )}
                <div className="modal-buttons">
                    {(type === 'confirm' || type === 'edit') && (
                        <button className="modal-btn modal-btn-cancel" onClick={onCancel}>
                            {cancelText}
                        </button>
                    )}
                    <button 
                        className={`modal-btn ${(type === 'confirm' || type === 'edit') ? 'modal-btn-confirm' : 'modal-btn-ok'}`}
                        onClick={onConfirm}
                    >
                        {confirmText}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Modal;
